import { isAxiosError } from "axios";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

/**
 * Prefer server-provided message (Spring `message`, body string, etc.),
 * not the generic axios "Request failed with status code …" line.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    const data = error.response?.data;
    if (typeof data === "string" && data.trim()) {
      return data.trim();
    }
    if (isRecord(data)) {
      const msg = data.message;
      if (typeof msg === "string" && msg.trim()) {
        return msg.trim();
      }
      const errors = data.errors;
      if (Array.isArray(errors) && errors.length > 0) {
        const first = errors[0];
        if (
          isRecord(first) &&
          typeof first.defaultMessage === "string" &&
          first.defaultMessage.trim()
        ) {
          return first.defaultMessage.trim();
        }
      }
    }
    const m = error.message?.trim() ?? "";
    if (m && !/^Request failed with status code \d+$/i.test(m)) {
      return m;
    }
    return fallback;
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }
  return fallback;
}
